import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUtilService } from '../core/services/api-util.service';
import { HttpClient } from '@angular/common/http';
import {AuthService} from '../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SpotsService {
  baseUrl = environment.apiUrl;
  apiKey = environment.apiKey;

  apiUtilService = inject(ApiUtilService);
  authService = inject(AuthService);

  constructor(private http: HttpClient) {}

  async getItemList(projectName: string): Promise<Observable<any>> {

    const body = {
      projectName: projectName,
    };

    return await this.apiUtilService.sendPostRequest(
      `cms/getItemList`,
      body
    );
  }

  async addItem(projectName: string, item: any): Promise<Observable<any>> {
    const payload = {
      projectName: projectName,
      items: [item],
    };

    return await this.apiUtilService.sendPostRequest(`cms/addItems`, payload);
  }

  async getItemsByQuery(projectName: string, query: string): Promise<Observable<any>> {
    const body = {
      query: query,
    };

    const url = `util/${projectName}/searchLocationByQuery`;

    return await this.apiUtilService.sendPostRequest(url, body);
  }

  async getItemById(projectName: string, id: string): Promise<Observable<any>> {
    const endpoint = 'getItems';

    const payload = {
      projectName: projectName,
      itemIds: [id],
    };

    return await this.apiUtilService.sendPostRequest(`cms/${endpoint}`, payload);
  }

  async deleteItem(projectName: string, id: string): Promise<Observable<any>> {
    const endpoint = 'deleteItems';

    const payload = {
      projectName: projectName,
      itemIds: [id],
    };

    return await this.apiUtilService.sendPostRequest(`cms/${endpoint}`, payload);
  }

  async getItemCsv(config: { projectName: string, filters?: any, itemIds?: string[] }): Promise<Observable<string>> {
    const {projectName, filters, itemIds} = config;
    const endpoint = 'getItemCsv';
    const body = {projectName: projectName, filters, itemIds};
    const token = await this.authService.getJwtToken();

    return this.http.post(`${this.baseUrl}cms/${endpoint}`, body, {
      responseType: 'text',
      headers: {
        'x-api-key': this.apiKey,
        'Authorization': `Bearer ${token}`
      },
    }) as Observable<string>;
  }

  async uploadCsv(
    file: File,
    deleteItems: boolean = false,
    projectName: string
  ): Promise<Observable<any>> {
    return new Observable((observer) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        const base64Data = reader.result as string;

        const payload = {
          projectName: projectName,
          data: {
            filename: file.name,
            data: base64Data,
          },
          deleteItems: deleteItems, // Optional flag
        };

        (await this.apiUtilService
          .sendPostRequest(`cms/buildItemCsv`, payload))
          .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            },
          });
      };

      reader.onerror = (error) => {
        observer.error(error);
      };
    });
  }

  async autoTranslateItem(item: any, targetLanguages: string[], projectName: string): Promise<Observable<any>> {
    const payload = {
      item: item,
      targetLanguages: targetLanguages,
      projectName: projectName,
    };

    return await this.apiUtilService.sendPostRequest(`cms/autoTranslate`, payload);
  }
}
